// ADR 23.9.26v §5 — the web's `OfflineBanner.swift`: one line, key
// `offline_banner`, rendered as the catalogue has it ("⚠" included) so the
// announced text and the visible text are the same string. The web's warning
// token rather than iOS's red at 15%, which this palette does not have.
//
// ADR 7.10.26ad §3 — two lines, one slot: `offline_banner` when the browser
// itself says offline, `offline_banner_connecting` (no "⚠": nothing has failed
// yet) when only the shared signal does — a slow launch past the boot
// deadline, or a transport failure on a link the browser still calls up.

import { useTranslation } from 'react-i18next'

import { useBrowserOnline, useOnlineStatus } from './onlineSignal'

function OfflineBanner({ connecting }: { connecting: boolean }) {
  const { t } = useTranslation()
  return (
    <div role="status" className="bg-warn px-4 py-2 text-sm text-on-warn">
      {t(connecting ? 'offline_banner_connecting' : 'offline_banner')}
    </div>
  )
}

/**
 * The shell's slot: always present, `null` online — 8.9.26i §4's rule for a
 * conditional row above the frame, so connectivity flapping never renumbers
 * the frame's children or remounts the `<Outlet>`. Shown for every session
 * state, the sign-in page included, where it explains the disabled form.
 */
export function OfflineBannerSlot() {
  const online = useOnlineStatus()
  const browserOnline = useBrowserOnline()
  return online ? null : <OfflineBanner connecting={browserOnline} />
}
